const en_master_courier = {
    add: "add courier",
    edit: "edit courier",
    name: "courier name",

    error: {
        create: "Failed to create courier.",
        delete: "Failed to delete courier.",
        edit: "Failed to update courier.",
        user: "User cannot be empty.",
    },

    success: {
        create: "Courier created successfully.",
        delete: "Courier deleted successfully.",
        edit: "Courier updated successfully.",
    }
}

export default en_master_courier;